package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.ability.*
import org.jbox2d.common.*

class AbilityControlSystem(

) : IteratingSystem(family { all(AbilityComponent) }) {

    override fun onTickEntity(entity: Entity) {
        val abilityComp = entity[AbilityComponent]

        abilityComp.body.applyLinearImpulse(abilityComp.direction, abilityComp.body.worldCenter, true)

        if (MathUtils.abs(abilityComp.body.linearVelocityX) > 3f) {
            abilityComp.body.linearVelocityX = if (abilityComp.body.linearVelocityX > 0) {
                3f
            } else {
                -3f
            }
        }

        if (MathUtils.abs(abilityComp.body.linearVelocityY) > 3f) {
            abilityComp.body.linearVelocityY = if (abilityComp.body.linearVelocityY > 0) {
                3f
            } else {
                -3f
            }
        }
    }
}
